'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var CommonLink = function (props) {
    var _a = props.url, url = _a === void 0 ? '/' : _a, text = props.text, _b = props.preventDefault, preventDefault = _b === void 0 ? false : _b, target = props.target, _c = props.rel, rel = _c === void 0 ? 'noopener noreferrer' : _c, onClick = props.onClick;
    var handleClick = function (event) {
        if (preventDefault) {
            event.preventDefault();
        }
        if (!onClick) {
            return;
        }
        onClick(event);
    };
    return (React__default.createElement(styledComponents.Container, null,
        React__default.createElement(styledComponents.StyledLink, { "data-testid": 'common-link', href: url, target: target, rel: rel, onClick: handleClick }, text)));
};

module.exports = CommonLink;
